<template>
  <h1>Nemate prava pristupa</h1>
</template>

<script>
export default {
  name: 'Forbidden',
};
</script>
